<template>
	<div>

		<div class="login-head fc-bet container">
			<div class="fc">
<!--				<a href="" class="logo fc" v-if="false">-->
<!--					<img src="@/assets/logo.jpg" alt="" srcset="">-->
<!--				</a>-->
				<div class="login-title">
					欢迎登陆
				</div>
			</div>
			<div class="login-right-logo">
				<a href="" class="fc">
					<img src="@/assets/logo-shop.png" alt="">
				</a>
			</div>
		</div>

		<div class="login-banner">
			<div class="container login-page pr">
				<div class="login-form">
					<div class="login-index fc-bet">
						<div class="tab fcc" :class="{on:tabIndex==1}" @click="tabIndex=1" v-if="false">
							手机登录
						</div>
<!--						<div class="line"></div>-->
						<div class="tab fcc" :class="{on:tabIndex==2}" @click="tabIndex=2">
							账号登录
						</div>
					</div>

					<!-- 手机登录 -->

<!--					<div class="phone-login" v-if="tabIndex==1">-->
<!--						<div class="msg-login"></div>-->
<!--						<div class="form-group">-->
<!--							<div class="pr ">-->
<!--								<div class="icon-user-box fcc"><i class="icon-user"></i></div>-->
<!--								<input type="text" v-model="phone" class="input" placeholder="手机号" maxlength="11">-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="form-group">-->
<!--							<div class="fc-bet">-->
<!--								<input type="text" class="input codeipt" placeholder="短信验证码">-->
<!--								<div class="btn-send-code" v-if="showSendSms">-->
<!--									<ge-code :config="config"></ge-code>-->
<!--								</div>-->
<!--								<div class="btn-send-code" v-else>-->
<!--									获取短信验证码-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="form-group" v-if="false">-->
<!--							<div class="pr">-->
<!--								<select name="" id="" class="phone-merchant">-->
<!--									<option value="">请选择经销商</option>-->
<!--								</select>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div style="height: 17px;"></div>-->
<!--						<div class="form-group mgB0">-->
<!--              <router-link to="index">-->
<!--							<button type="button" class="btn btn-one big red fcc">-->
<!--								登录-->
<!--							</button>-->
<!--              </router-link>-->
<!--						</div>-->
<!--					</div>-->

					<!-- 账号登录 -->
					<div class="identity-login" >
						<div class="msg-login"></div>
						<div class="form-group">
							<div class="pr ">
								<div class="icon-user-box fcc"><i class="icon-user"></i></div>
								<input type="text" class="input" v-model="count" placeholder="账号" maxlength="11">
							</div>
						</div>
						<div class="form-group">
							<div class="pr ">
								<div class="icon-user-box fcc"><i class="icon-suo"></i></div>
								<input type="password" v-model="password" class="input" placeholder="密码" maxlength="11"
									v-if="pwd_hide">
								<input type="text" v-model="password" class="input" placeholder="密码" maxlength="11"
                       v-if="!pwd_hide">
<!--								<img src="@/assets/pwd_hide.svg" class="passwordImg" alt="" v-if="pwd_hide"-->
<!--									@click="pwd_hide=!pwd_hide">-->
<!--								<img src="@/assets/pwd_show.svg" class="passwordImg" alt="" v-if="!pwd_hide"-->
<!--									@click="pwd_hide=!pwd_hide">-->

							</div>
						</div>
<!--						<div class="form-group" v-if="false">-->
<!--							<div class="pr">-->
<!--								<select name="" id="" class="phone-merchant">-->
<!--									<option value="">请选择经销商</option>-->
<!--								</select>-->
<!--							</div>-->
<!--						</div>-->
						<div class="forgot fc-bet">
							<router-link class="regis fc" to="reset-pwd">
															<i></i>忘记密码
							</router-link>
							<div class="fc">
								<label  class="checkboxStyle checkBox1" style="margin-right: 5px!important;">
									<input type="checkbox" :checked="checked" @click="checked=!checked" class="chk chk-all checkBoxFoot"><span></span>
								</label>
								<span @click="checked=!checked">我已阅读并且同意</span>
								<span style="cursor: pointer;color: #57ACA7;"  @click="dialogVisible = true">用户协议</span>
							</div>
						</div>

						<div class="form-group mgB0">
              <button type="button" class="btn btn-one big red fcc" style="color: #ffffff"  @click="loginSubmit">
                登录
              </button>
						</div>
					</div>




					<div class="union-login fc-bet">
						<div></div>
						<router-link class="regis fc" to="reg">
							<i class="op-icons op-icons-regis"></i>免费注册
						</router-link>

					</div>


				</div>
			</div>
		</div>




		<el-dialog
		  title="天正智选平台用户注册协议"
		  :visible.sync="dialogVisible"
		  width="1000px"
		  :before-close="handleClose">
		  <div style="height: 60vh;overflow-y: auto; padding-right: 20px;">

			  <p ><strong>一、平台</strong><strong>服务</strong><strong><br />
			    </strong><br />
			    1、智选平台致力于打造便捷化商务订单，通过互联网及相关软硬件设施为注册会员提供质优价廉的电气产品！智选平台秉承客户至上的经营理念，为用户提供优质服务，让用户获取完美网购体验。<br />
			    <br />
			    2、智选平台的网站所有权、运作权及所涉及的一切知识产权归浙江天正电气股份有限公司（下称“天正公司”）所有。用户在享受智选平台提供服务同时，应受本协议条款的约束。用户通过注册流程并完成注册，表示用户完全理解并接受本协议的各项条款，在享有条款授予权利的同时， 受到相关的约束和限制。当用户在使用智选平台各单项服务时，用户享受服务的行为被视为对单项服务条款以及该单项服务中发出的各类公告的认可。 </p>
			  <p >&nbsp;</p>
			  <p ><strong>二、说明与保证</strong><strong><br />
			    </strong><br />
			    1、 智选平台保证所有商品均为授权经销商提供。<br />
			    <br />
			    2、 智选平台尽最大努力确保网站图片与实物的一致性，但由于拍摄角度、光线强度、不同显示器的色差等客观因素仍有可能导致出现误差，此种情况不属于质量问题范畴。图片仅供参考，一切以实物为准。<br />
			    <br />
			    3、 有关商品质量的检测，依国家、行业标准执行。<br />
			    <br />
			    <br />
			    <br />
			    三、<strong>注册与使用</strong><strong><br />
			    </strong><br />
			    1、用户注册时需提供营业执照及使用人员的手机号码，用户应当确保其提供的信息的真实性、正确性、完整性，该类信息更新时，用户应当自行及时在智选平台上进行修改操作。因用户提供虚假信息或者因信息资料滞后造成的损失由用户自行承担。 </p>
			  <p >2、用户注册成为会员，将拥有一个专属于个人的用户名和密码，请妥善保管。因个人保管不善引起的责任，由个人承担。除非经司法裁定或者征得天正公司同意，用户账户不得以任何方式进行转让、赠予或者继承。<br />
			      <br />
			    3、用户承诺对智选平台及相关服务的使用符合部门规章、国家法律的规定，并对自己发布的内容以及对通过账户实施的行为独立承担责任。<br />
			    <br />
			    4、用户承诺在平台上发布信息或者利用智选平台的服务时必须符合中国有关法规，不在智选平台的网页上或者利用智选平台的服务制作、复制、发布、传播以下信息：<br />
			    <br />
			    （1）违反国家各项法律法规的以及法律法规禁止的、泄露国家机密、破坏国家统一的；<br />
			    （2）危害国家安全、破坏名族团结、损害国家利益的；<br />
			    （3）破坏国家宗教政策、宣扬邪教和封建迷信的；<br />
			    （4）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
			    （5）侮辱或者诽谤他人，侵害他人合法利益的。<br />
			    <br />
			    5、用户承诺不利用智选平台提供的服务从事制作、传播计算机病毒等破坏性程序；不从事危害计算机信息网络安全的行为；不以任何方式干扰智选平台的正常运行。<br />
			      <br />
			    6、用户不得在平台上进行虚假交易或骗取积分，若发生相关事项，其法律后果及法律责任由用户承担，给天正公司及其经销商造成损失的，用户还应赔偿损失。<br />
			    <br />
			    <br />
			    <strong>四、</strong><strong>隐私</strong><strong>保护</strong><strong> </strong><br />
			    <br />
			    1、智选平台为用户带来便捷服务的同时，充分尊重和保护个人信息和隐私。智选平台不会公开、修改或透露用户的注册资料及保存在智选平台各项服务中的非公开内容。<br />
			    <br />
			    2、如用户同意智选平台或者要求智选平台可以透露某些信息的，或者在法律法规要求下需要智选平台提供个人信息的，或者智选平台认为确其它必要的，智选平台会在诚信的基础上、确有必要的前提下公开。<br />
			    <br />
			    3、智选平台的信息服务是根据用户主动申请而提供的，除了少量的服务动态信息，我们不会任意推送无关的信息到用户的手机短信。<br />
			    <br />
			    <br />
			    <strong>五、责任限制</strong><strong><br />
			      </strong><br />
			    用户明确同意会员服务的使用由用户个人承担风险，智选平台不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、安全性不作任何担保。智选平台拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。<br />
			    <br />
			    <br />
			    <strong>六、</strong><strong>修订</strong><strong>与通知</strong><strong><br />
			      </strong><br />
			    1、智选平台会在必要时修改服务条款，服务条款一旦发生变动，将会在重要页面上提示修改内容或通过其他形式告知用户。<br />
			    <br />
			    2、所有重要信息的通告，包括条款的修改、服务变更等重要事情，网站可以以电子邮件、站内消息、网站页面显要位置公告的形式告知用户。<br />
			    <br />
			    <strong>七、</strong><strong>结束服务</strong><strong><br />
			      </strong><br />
			    用户或者智选平台可随时根据实际情况中止网站服务。结束用户服务后，用户使用智选平台会员服务的权利马上中止，智选平台不再对用户承担任何义务。<br />
			    <br />
			    <br />
			    <strong>八、其他</strong><strong><br />
			    </strong>1、本协议各条款独立，部分条款无效不影响其他条款及本协议的效力。如双方就本协议内容或因履行本协议发生任何争议，双方应尽力友好协商解决；协商不成的，任何一方均可本站所在地的人民法院提起诉讼。 </p>
			  <p >2、本协议及智选平台使用规则最终解释权归天正所有。 </p>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>


		<i-footer></i-footer>

	</div>
</template>

<script>
	import geCode from 'vue-gecode'
  import { mapMutations } from 'vuex'
  import { getUserInfo, loginWeb } from '@/api/login'
  import { refreshUserInfo, saveUserInfo, setUserToken } from '@/utils/auth'
	export default {
		components: {
			geCode
		},
		data() {
			return {
				dialogVisible:false,
				checked:true,
				tabIndex: 1,
				phone: null,

				count: "",
				password: "",
				pwd_hide: true,
				config: {
					//开始时候的文本
					startText: '获取短信验证码',
					//获取验证码结束后文本
					endText: '再次获取',
					//验证码倒计时总时间(秒)
					totalTime: 60,
					//验证码每次隔多久变一次(秒)
					tickTime: 1,
					//倒计时执行期添加的class 默认 isRun
					activeClass: 'isRun',
					//自定义倒计时期间文本的显示内容
					computeText(num) {
						//num 倒计时时间
						return '重新获取 ' + num + 's';
					},
					//是否可以发送
					canTodo: () => {
						//返回值判定是否可以发送
						let result = /^1[3456789]\d{9}$/.test(Number(this.phone));
						console.log('判断是否可以发送验证码', result);
						if (!result) {
							alert('手机号格式不正确');
						}
						return result;
					},
					//canTode验证成功后执行 发送短信验证码
					todo: () => {
						//这里写验证码的获取程序
						console.log('发送验证码')
						//同时手机号不可改变了
						this.readonly = true
					},
					//发送完成后的回调
					endCallback(type, config) {
						//type 回调产生原因  0: 时间结束   其他值由this.$refs.geCode.stop(1)调入自定义
						//config config配置
						console.log('发送完成后的回调', type, config);
						//同时手机号可改变了
						this.readonly = false
					},
					//每次点击都会被调用
					click(isRun) {
						//isRun 是否在运行中
						console.log(`当前验证码状态是:${isRun ? '发送中' : '可发送'}状态`)
					},
					//是否可用   默认ture
					canUse: true,
					//不可用时的类名  默认no-can
					noCanClass: 'no-can',
				},


			}
		},
		mounted() {


		},
		computed: {

			showSendSms() {
				let result = /^1[3456789]\d{9}$/.test(Number(this.phone));
				console.log("验证码", result)
				return result
			}
		},
		methods: {
      ...mapMutations({
        setCartNum: 'SET_CARTNUM' // 修改购物车商品数量
      }),
		agreementBox(){

		},
			sendCode() {
				this.$refs.timerbtn.setDisabled(true); //设置按钮不可用

			},
      loginSubmit(){
        console.log(this.checked)
        //校验
        if (!this.checked){
          this.$message.error('请同意《天正用户协议》');
          return
        }
        //跳转
        let loginParam = {
          username:this.count,
          password:this.password
        }
        loginWeb(loginParam).then(res=>{
          console.log('登录后的信息',res)
          if (res.status === 200) {
            setUserToken(res.data.token, res.data.expires_time)
            saveUserInfo(res.data.userInfo)
            this.$message.success('登录成功')
            this.$router.push('/')
            this.getUserInfo()
            this.getCartNum()
            // this.handleClose()
            // location.reload()
          } else {
            this.$message.warning(res.msg)
          }
        })
      },
      // 获取用户信息
      async getUserInfo () {
        const res = await getUserInfo()
        if (res.status === 200) {
          refreshUserInfo(res.data)
        }
      },
		},


	}
</script>

<style>

</style>
